
  $(document).ready(function(){ 
    var navHeight = $('.main-navigation').outerHeight();
    $('#MainContent').css('margin-top', navHeight + 'px');
  });


  /* Grid View */

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#product-grid');
  const triggers = document.querySelectorAll('.view-trigger');

  if (!grid || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const isGrid = trigger.classList.contains('grid-view');
      const isList = trigger.classList.contains('list-view');

      grid.classList.remove('grid-view', 'list-view');
      triggers.forEach(t => t.classList.remove('active'));

      if (isGrid) {
        grid.classList.add('grid-view');
      }

      if (isList) {
        grid.classList.add('list-view');
      }

      trigger.classList.add('active');
    });
  });
});

/* --------------------------
   UNIVERSAL ADD-TO-CART LISTENER
--------------------------- */

// 1. Button click (ANY add-to-cart button)
document.addEventListener("click", (e) => {
  if (e.target.closest('[name="add"]') || e.target.closest('.ProductForm__AddToCart')) {
    console.log("🟠 Add to cart button clicked");
    fireStarConfetti();
  }
});

// 2. Shopify AJAX / ProductForm add-to-cart
document.addEventListener("product:added", (e) => {
  console.log("🟢 product:added event fired");
  fireStarConfetti();
});

// 3. UpCart public event
window.addEventListener("aftersell-upcart:public-events:cart-updated", (e) => {
  console.log("🔵 UpCart cart-updated fired");
  fireStarConfetti();
});

// 4. Intercept ANY fetch to /cart/add.js (works for AJAX carts)
const originalFetch = window.fetch;
window.fetch = function() {
  const url = arguments[0];

  if (typeof url === "string" && url.includes("/cart/add")) {
    console.log("🟣 fetch → /cart/add detected");
    fireStarConfetti();
  }

  return originalFetch.apply(this, arguments);
};

// XHR fallback
const originalSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function(body) {
  this.addEventListener("load", () => {
    if (this.responseURL && this.responseURL.includes("/cart/add")) {
      console.log("🟡 XHR → /cart/add detected");
      fireStarConfetti();
    }
  });
  originalSend.call(this, body);
};


/* --------------------------
   CONFETTI FUNCTION
   --------------------------- */
   
function fireStarConfetti() {
  console.log("🎉 fireStarConfetti() triggered");

  const starUrl = "https://cdn.shopify.com/s/files/1/0043/1548/0177/files/star.png?v=1763353658";

  const duration = 2800; // 5 seconds
  const interval = 80; // how often to drop new stars
  const endTime = Date.now() + duration;

  const dropInterval = setInterval(() => {
    if (Date.now() > endTime) {
      clearInterval(dropInterval);
      console.log("⏹ Confetti ended");
      return;
    }

    createStarParticle(starUrl);

  }, interval);
}

function createStarParticle(starUrl) {
  const particle = document.createElement("img");
  particle.src = starUrl;
  particle.classList.add("star-confetti");

  // Random size 10–20px
  const size = Math.floor(Math.random() * 11) + 20;

  // Full width random start position (0 → viewport width)
  const startX = Math.random() * window.innerWidth;

  // Random drift left/right
  const driftX = Math.random() * 200 - 100;

  const rotation = Math.random() * 360;

  particle.style.position = "fixed";
  particle.style.left = `${startX}px`;
  particle.style.top = "-20px";
  particle.style.width = `${size}px`;
  particle.style.height = `${size}px`;
  particle.style.pointerEvents = "none";
  particle.style.opacity = "1";
  particle.style.transform = `rotate(${rotation}deg)`;
  particle.style.zIndex = "999999";

  document.body.appendChild(particle);

  const fallDuration = 1800 + Math.random() * 1200; // 1.8s–3s
  const endY = window.innerHeight + 40;

  particle.animate(
    [
      { transform: `translate(0, 0) rotate(${rotation}deg)`, opacity: 1 },
      { transform: `translate(${driftX}px, ${endY}px) rotate(${rotation + 120}deg)`, opacity: 0 }
    ],
    {
      duration: fallDuration,
      easing: "ease-out"
    }
  );

  setTimeout(() => particle.remove(), fallDuration + 50);
}
